"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawAdjustmentChunkProcessor = void 0;
var _adjustmentDataCollection = require("./adjustmentDataCollection");
var _adjustmentDataVerifier = require("./adjustmentDataVerifier");
var _adjustmentValidator = require("../entry/adjustmentValidator");
var _adjustmentParser = require("@/entry/adjustmentParser");
var _chunkParser = require("./chunkParser");
var _config = require("@/config");
class RawAdjustmentChunkProcessor {
  constructor({
    cache,
    snowflakeClient
  }) {
    this.cache = cache;
    this.snowflakeClient = snowflakeClient;
    this.parser = new _adjustmentParser.AdjustmentParser();
    this.chunkParser = new _chunkParser.ChunkParser({
      parser: this.parser
    });
    this.verifier = new _adjustmentDataVerifier.AdjustmentDataVerifier({
      cache: this.cache,
      snowflakeClient: this.snowflakeClient
    });
  }
  async process(chunk) {
    // Parse
    const parsed = this.chunkParser.parse(chunk);

    // Collect
    const collection = new _adjustmentDataCollection.AdjustmentDataCollection();
    parsed.data.forEach(({
      value
    }) => collection.add(value));

    // Verify
    const cache = await this.verifier.verify(collection);

    // Validate
    let n = 0;
    const data = parsed.data;
    const validator = new _adjustmentValidator.AdjustmentValidator({
      cache,
      enableCloseBalanceStatuses: !_config.config.isDryRun,
      enableStatementDate: !_config.config.isDryRun
    });
    for (const entry of data) {
      const {
        errors
      } = validator.validate(entry.value);
      if (errors == null) {
        data[n++] = entry;
      } else {
        parsed.errors.push({
          index: entry.index,
          value: errors
        });
      }
    }
    data.length = n;
    return parsed;
  }
}
exports.RawAdjustmentChunkProcessor = RawAdjustmentChunkProcessor;